import { useState, useCallback } from 'react';

interface TestimonialData {
  name: string;
  quote: string;
}

const testimonials: TestimonialData[] = [
  {
    name: 'Rosely Faustini',
    quote: 'Com certeza, a melhor escolha! Um ambiente acolhedor, com professores qualificados e, acima de tudo, fundamentado em princípios cristãos.',
  },
  {
    name: 'Déborah V P',
    quote: 'Professores incríveis, dedicados e apaixonados pelo que fazem. A metodologia é clara, adaptada a cada aluno, e o ambiente é super acolhedor e motivador. Meu filho está evoluindo muito rápido, parabéns pela dedicação em ensinar música.',
  },
  {
    name: 'Daniela Viana',
    quote: 'Uma escola abençoada! O ensino é de excelente qualidade, com professores capacitados e comprometidos tanto com a música quanto com os valores cristãos. Eu e meus filhos estamos aprendendo muito, não só tecnicamente, mas também sobre como usar a música para adorar o Senhor. Super recomendo para quem deseja crescer musicalmente e espiritualmente!',
  },
];

const FIXED_AVATAR_URL = 'https://static.readdy.ai/image/e52027607460cffc32b49812e98784ba/386c7c72be2eb43fd23b996dd5858c7e.png';

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % testimonials.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  }, []);

  const t = testimonials[current];

  return (
    <section id="depoimentos" className="relative w-full bg-white py-16 md:py-20">
      <div className="w-full px-6 md:px-12 lg:px-16">
        <div className="flex flex-col items-center text-center gap-3 mb-16">
          <span className="font-sans text-[11px] font-semibold tracking-[0.2em] uppercase text-vibrant-blue bg-light-blue/10 px-4 py-2 rounded-full">
            Depoimentos
          </span>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-night-blue leading-[1.15] tracking-tight">
            Deus não une pessoas,
            une propósitos.
          </h2>
          <div className="flex items-center gap-1">
            {[...Array(5)].map((_, i) => (
              <span key={i} className="w-5 h-5 flex items-center justify-center">
                <i className="ri-star-fill text-vibrant-blue text-lg"></i>
              </span>
            ))}
          </div>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="w-full lg:w-[40%] flex-shrink-0">
              <div className="relative w-full max-w-[340px] mx-auto aspect-square rounded-[32px] overflow-hidden bg-light-blue/20">
                <img
                  src={FIXED_AVATAR_URL}
                  alt="TL Artes & Música"
                  title="TL Artes & Música - Depoimentos"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="w-full lg:w-[60%] flex flex-col gap-8">
              <div className="flex flex-col gap-1">
                <span className="font-sans text-[13px] font-medium text-night-blue-light tracking-wide">
                  &mdash; O que dizem sobre nós
                </span>
              </div>

              <h3 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold leading-[1.25] tracking-tight">
                <span className="text-night-blue">Transformando vidas</span><br />
                <span className="text-vibrant-blue">através da música</span>
              </h3>

              <blockquote className="relative">
                <i className="ri-double-quotes-l text-4xl text-light-blue/30 absolute -top-3 -left-1"></i>
                <p className="font-sans text-[15px] md:text-base text-gray-500 leading-[1.8] pl-8">
                  {t.quote}
                </p>
              </blockquote>

              <div className="flex flex-col gap-0.5">
                <span className="font-sans text-sm font-semibold text-night-blue">&mdash; {t.name}</span>
              </div>

              <div className="flex items-center gap-3 pt-2">
                <button
                  onClick={prev}
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-200 hover:border-gray-300 text-gray-400 hover:text-night-blue transition-all duration-300 cursor-pointer"
                  aria-label="Depoimento anterior"
                >
                  <i className="ri-arrow-left-line text-lg"></i>
                </button>
                <button
                  onClick={next}
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-night-blue hover:bg-night-blue-light text-white transition-all duration-300 cursor-pointer"
                  aria-label="Próximo depoimento"
                >
                  <i className="ri-arrow-right-line text-lg"></i>
                </button>
                <span className="font-sans text-[13px] text-gray-400 font-light ml-2">
                  {current + 1} / {testimonials.length}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}